import * as z from 'zod';

export const GetCheckoutContentRequest = z.object({
  identifiers: z.object({
    appId: z
      .string()
      .describe('ID of the app that provides the content.')
      .regex(
        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
        'Must be a valid GUID'
      ),
    componentId: z
      .string()
      .describe('ID of the specific component content.')
      .regex(
        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
        'Must be a valid GUID'
      ),
  }),
  options: z
    .object({
      languageCode: z
        .string()
        .describe(
          'When a language is specified, it will be retrieved the content in that language.'
        )
        .min(1)
        .max(20)
        .optional()
        .nullable(),
    })
    .optional(),
});
export const GetCheckoutContentResponse = z.object({
  checkoutContent: z
    .object({
      continueShoppingLink: z
        .string()
        .describe('Text to display in place of the "Continue shopping" link.')
        .min(1)
        .max(30)
        .optional()
        .nullable(),
      orderSummary: z
        .string()
        .describe('Text to display in place of the "Order summary" title.')
        .min(1)
        .max(30)
        .optional()
        .nullable(),
      customerDetails: z
        .string()
        .describe('Text to display in place of the "Customer details" title.')
        .min(1)
        .max(30)
        .optional()
        .nullable(),
      reviewAndPlaceOrder: z
        .string()
        .describe(
          'Text to display in place of the "Review and place order" title.'
        )
        .min(1)
        .max(50)
        .optional()
        .nullable(),
      placeOrderButton: z
        .string()
        .describe('Text to display in place of the "Place order" button.')
        .min(1)
        .max(50)
        .optional()
        .nullable(),
      placeOrderPayButton: z
        .string()
        .describe('Text to display in place of the "Place order & pay" button.')
        .min(1)
        .max(50)
        .optional()
        .nullable(),
    })
    .describe('The requested CheckoutContent.')
    .optional(),
});
